import React from "react";

const ImageLoading = (props) => {
  return (
    <div className="loading-animation" style={{ ...props, width: props.width, height: props.height, aspectRatio: props.aspectRatio }}></div>
  );
};

export default ImageLoading;
